import { StageProvider } from "@hg/recall-frame"
import React, { useMemo } from "react"

import Toast from "@/components/Toast"
import { i18n, RecallTextPath } from "@/i18n"
import { sdkReady } from "@/utils/sdk"
import { errMsgMap } from "./const/errMsg"
import { Home } from "./Home"

export const Recall = () => {
    const message = (msg: string) => Toast.message(msg)

    const errMsgLocaleMap = useMemo(() => {
        const result: Record<string, string> = {}
        Object.entries(errMsgMap).forEach(([code, key]) => {
            result[code] = i18n.getRecall(key as RecallTextPath) || ""
        })
        return result
    }, [])

    return (
        <StageProvider
            activityId={__ACTIVITY_CID}
            couponId={__RECALL_COUPON_CID}
            baseURL={__ACT_SERVER_HOST}
            sdkReady={sdkReady}
            message={message}
            renderMain={() => <Home />}
            errCodeMsgMap={errMsgLocaleMap}
        />
    )
}
